import React from 'react';
import { useWizard } from '../useWizard';
import BasicInfoForm from '../forms/BasicInfoForm';
import { WIZARD_STEPS } from '../../../types/wizard';

const BasicInfoStep: React.FC = () => {
  const { state, stepErrors, updateBasicInfo } = useWizard();
  const errors = stepErrors[WIZARD_STEPS.BASIC_INFO] || {};

  return (
    <div className="wizard-step">
      <h2>Basic Information</h2>
      <p className="step-description">Enter the clinic name, address, and contact details.</p>

      {/* showCode={false}: the clinic code is assigned server-side on create
          (usp_CreateClinic → uspGetNextClinicCode) and is not user-entered. */}
      <BasicInfoForm
        values={state.basicInfo}
        onChange={updateBasicInfo}
        errors={errors}
        showCode={false}
      />
    </div>
  );
};

export default BasicInfoStep;
